export default __webpack_public_path__ + "static/media/Glenallen Mixon.b01502be.jpg";